import Web3 from 'web3';
import { ADDRESS_RACEXNFKEY, ADDRESS_RACEXCARNFT, ADDRESS_RACEX, ADDRESS_RACEXREFLECT, PUBLIC_SALE_PRICE } from '../constants';
import ABI_RaceXNFKey from '../constants/ABI/ABI_RaceXNFKey.json';
import ABI_RaceXCarNFT from '../constants/ABI/ABI_RaceXCarNFT.json';
import ABI_RaceX from '../constants/ABI/ABI_RaceX.json';
import ABI_RaceXReflect from '../constants/ABI/ABI_RaceXReflect.json';

const web3 = new Web3(Web3.givenProvider)

export const getCountNFKeys = async (address) => {
  const contract = new web3.eth.Contract(ABI_RaceXNFKey, ADDRESS_RACEXNFKEY)
  const countNFKeys = await contract.methods.balanceOf(address).call()
  return countNFKeys
}

export const getNFKeyIDByIndex = async (address, index) => {
  const contract = new web3.eth.Contract(ABI_RaceXNFKey, ADDRESS_RACEXNFKEY)
  const nfKeyId = await contract.methods.tokenOfOwnerByIndex(address, index).call()
  return nfKeyId
}

export const getNFKeyByID = async (id) => {
  const contract = new web3.eth.Contract(ABI_RaceXNFKey, ADDRESS_RACEXNFKEY)
  const baseURI = await contract.methods.baseURI().call()
  const ipfsURL = 'https://ipfs.io/ipfs/' + baseURI.split('/')[2] + '/' + id + '.json'
  const _res = await fetch(ipfsURL)
  const _data = await _res.json()
  _data.name = _data.name.replace('DCRC', '').replace('#', '').replace('Keys', 'Key')
  _data.id = id
  _data.video = 'https://ipfs.io/ipfs/' + _data.image.split('//')[1]
  return _data
}

export const getMyRaceXCars = async (account) => {
  const raceXCarcontract = new web3.eth.Contract(ABI_RaceXCarNFT, ADDRESS_RACEXCARNFT)
  const _tokens = await raceXCarcontract.methods.getMyTokens(account).call()
  let myCars = []
  for (let idx = 0; idx < _tokens.length; idx++) {
    if (_tokens[idx][1] != '') {
      const _res = await fetch(_tokens[idx][1])
      const _data = await _res.json()
      _data.name = _data.name.replace('DCRC', '').replace('#', '')
      myCars.push(_data)
    }
  }
  return myCars
}

export const getRound = async () => {
  const raceXCarcontract = new web3.eth.Contract(ABI_RaceXCarNFT, ADDRESS_RACEXCARNFT)
  const tokensMinted = await raceXCarcontract.methods.tokensMinted().call()
  const maxSupply = await raceXCarcontract.methods.maxSupply().call()
  let round = 1
  if (tokensMinted >= 1745 && tokensMinted <= 6000 ) round = 2
  else if (tokensMinted > 6000 && tokensMinted <= 8000 ) round = 3
  else if (tokensMinted > 8000 && tokensMinted <= 10000 ) round = 4
  return { round, tokensMinted, maxSupply };
}

export const getBalancePublicPrice = async (account) => {
  const raceXContract = new web3.eth.Contract(ABI_RaceX, ADDRESS_RACEX)
  let balance = await raceXContract.methods.balanceOf(account).call()
  balance = web3.utils.fromWei(balance)

  const _nfKeys = await getCountNFKeys(account)

  let price = 0
  const { round } = await getRound()
  if (balance > 0 && _nfKeys > 0) price = PUBLIC_SALE_PRICE[round] * 0.75
  else if (balance > 1000 * 1000) price = PUBLIC_SALE_PRICE[round] * 0.78
  else if (balance > 500 * 1000) price = PUBLIC_SALE_PRICE[round] * 0.85
  else if (balance > 0) price = PUBLIC_SALE_PRICE[round] * 0.9
  else price = PUBLIC_SALE_PRICE[round]
  return {balance, price}
}

export const mint = async (_to, _mintAmount, account) => {
  const { price } = await getBalancePublicPrice(account)
  const _amount = _mintAmount * price
  const raceXCarcontract = new web3.eth.Contract(ABI_RaceXCarNFT, ADDRESS_RACEXCARNFT)
  try {
    const _res = await raceXCarcontract.methods.mint(_to, _mintAmount)
        .send({
          from: account,
          value: web3.utils.toWei(_amount.toString(), 'ether')
        })
    return _res
  } catch (err) {
    console.log(err)
  }
  return
}

export const getReflectionBalance = async (account) => {
  const raceXReflectContract = new web3.eth.Contract(ABI_RaceXReflect, ADDRESS_RACEXREFLECT)
  try {
    let keyReflection = await raceXReflectContract.methods.getKeyReflectionBalance(account).call()
    keyReflection = web3.utils.fromWei(keyReflection, 'ether')
    keyReflection = Math.floor(parseFloat(keyReflection) * 100000) / 100000
    let carReflection = await raceXReflectContract.methods.getCarReflectionBalance(account).call()
    carReflection = web3.utils.fromWei(carReflection, 'ether')
    carReflection = Math.floor(parseFloat(carReflection) * 100000) / 100000
    return { keyReflection, carReflection }
  } catch (err) {
    console.log(err)
  }
  return
}

export const claimCarReflection = async (account) => {
  const raceXReflectContract = new web3.eth.Contract(ABI_RaceXReflect, ADDRESS_RACEXREFLECT)
  try {
    const _res = await raceXReflectContract.methods.claimCarReflection().send({from: account})
    const reflection = await getReflectionBalance(account)
    return reflection
  } catch (err) {
    console.log(err)
  }
  return
}

export const claimKeyReflection = async (account) => {
  const raceXReflectContract = new web3.eth.Contract(ABI_RaceXReflect, ADDRESS_RACEXREFLECT)
  try {
    const _res = await raceXReflectContract.methods.claimKeyReflection().send({from: account})
    const reflection = await getReflectionBalance(account)
    return reflection
  } catch (err) {
    console.log(err)
  }
  return
}